import { enqueueToast } from '@/features/toasts/slice'
import { useAppDispatch } from '@/redux/hooks'
import { useSetMediaArchivedMutation } from '../api'

export const useSetArchived = () => {
  const dispatch = useAppDispatch()
  const [trigger] = useSetMediaArchivedMutation({
    fixedCacheKey: 'set-archived',
  })

  const setArchived = async (mediaCodes: number[]) => {
    try {
      await trigger(mediaCodes).unwrap()
      dispatch(
        enqueueToast({
          message: `Archived ${mediaCodes.length} media item(s).`,
          severity: 'success',
        }),
      )
    } catch (error) {
      console.error('Failed to archive media', error)
      dispatch(
        enqueueToast({
          message: 'Unable to archive media.',
          severity: 'error',
        }),
      )
    }
  }

  return { setArchived }
}
